import { createContext, useCallback, useContext, useMemo, useState } from "react";

const ModalContext = createContext();

export const ModalProvider  = ({ children }) => {

    const [ modalStack, setModalStack ] = useState([]);

    const openModal = useCallback(
        ( id ) => setModalStack(( stack ) => [ ...stack, id ]),
        []
    );
    const closeModal = useCallback(
        () => setModalStack(( stack ) => stack.slice( 0, stack.length - 1 )),
        []
    );

    const isModalOpen = useCallback(
        ( id ) => modalStack.includes( id ),
        [ modalStack ]
    );
    const getTopModal = useCallback(
        () => modalStack[ modalStack.length - 1 ],
        [ modalStack ]
    );

    const clearAllModal = useCallback(() => setModalStack([]), []);

    const value = useMemo(
        () => ({ isModalOpen, openModal, closeModal, getTopModal, clearAllModal }),
        [ isModalOpen, openModal, closeModal, getTopModal, clearAllModal ]
    );

    return(
        <ModalContext.Provider value={ value } >
            { children }
        </ModalContext.Provider>
    )

}

export const useModal = () => useContext( ModalContext )